/**
 * Scroll Hero component.
 */
(() => {
  if (customElements.get("scroll-hero")) {
    return;
  }

  class ScrollHero extends HTMLElement {
    /**
     * Constructor.
     */
    constructor() {
      super();
      this.offset = 500;
      this.scheduledAnimationFrame = false;
    }

    /**
     * Check scroll position.
     */
    checkScrollPosition() {
      this.wrappers.forEach((wrapper, index) => {
        const hasPassedOffset =
          wrapper.getBoundingClientRect().top < this.offset;

        this.mediaElements[index].classList.toggle(
          "is-visible",
          hasPassedOffset
        );
      });

      this.scheduledAnimationFrame = false;
    }

    /**
     * On scroll and resize.
     *
     * @returns {Void}
     */
    onScrollAndResize() {
      if (this.scheduledAnimationFrame) {
        return;
      }

      this.scheduledAnimationFrame = true;
      window.requestAnimationFrame(this.checkScrollPosition.bind(this));
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.wrappers = this.querySelectorAll("[data-wrapper]");
      this.mediaElements = this.querySelectorAll("[data-media]");
      this.checkScrollPosition();
      this.setHandlers();
    }

    /**
     * Set handlers.
     */
    setHandlers() {
      ["scroll", "resize"].forEach((event) => {
        window.addEventListener(event, this.onScrollAndResize.bind(this));
      });
    }
  }

  customElements.define("scroll-hero", ScrollHero);
})();
